import { graphql, readInlineData } from "react-relay";

import { checkIsPostMagazineArticle } from "scmp-app/components/article/article-render/post-magazine-article/helper";
import { checkIsStyleArticle } from "scmp-app/components/article/article-render/style-article/helper";
import {
  checkIsMagazineSectionContent,
  checkIsSectionContent,
} from "scmp-app/components/section/helpers";
import { Variant as SectionVariant } from "scmp-app/pages/section/enums";
import type { helpersAppBarVariantBase$key } from "scmp-app/queries/__generated__/helpersAppBarVariantBase.graphql";

import type { AppBarVariant } from "./types";

export const AppBarColorScheme: Record<AppBarVariant, "dark" | "light"> = {
  none: "light",
  "scmp/generic-light": "light",
  "scmp/generic-light-with-banner-ad": "light",
  "scmp/home": "light",
  "scmp/magazines-style": "light",
  "scmp/plus": "light",
  "scmp/plus/learnmore": "light",
  "scmp/postmag": "light",
  "scmp/slim": "light",
};

export const getAppBarVariant = (reference: helpersAppBarVariantBase$key) => {
  const content = readInlineData(
    graphql`
      fragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias @inline {
        ...helpersCheckIsLiveArticle
        ...helpersCheckIsPlusPage
        ...helpersCheckIsPostMagazineArticle
        ...helpersCheckIsStyleArticle
        ...helpersSectionContent
        ...helpersStyleSectionContent
      }
    `,
    reference,
  );

  if (
    checkIsStyleArticle(content) ||
    checkIsMagazineSectionContent(content) === SectionVariant.Style
  )
    return "scmp/magazines-style";
  if (checkIsPostMagazineArticle(content)) return "scmp/postmag";
  if (checkIsSectionContent(content)) return "scmp/slim";

  return "scmp/generic-light";
};

export const getShouldShowAdBelowAppBar = (appBarVariant: AppBarVariant) => {
  switch (appBarVariant) {
    case "scmp/generic-light":
      return true;
    default:
      return false;
  }
};
